import { useQuery } from '@tanstack/react-query';

import { apiClient, type Order } from '@api';
import { QueryKeys } from '@config';

/**
 * Retrieves a single order by id.
 *
 * Required params: order id string.
 * Preconditions: user must be authenticated (bearer token via interceptor).
 * Important behavior: query is disabled until orderID is truthy; supports custom query options.
 *
 * @example
 * const { data: order, isPending } = useGetOrder(orderId);
 */
export const useGetOrder = (orderID: string, options: object = {}) => {
  return useQuery<Order | undefined>({
    queryKey: [QueryKeys.ORDERS, orderID],
    queryFn: async () => {
      const response = await apiClient.ordersRetrieve({
        path: { identifier: orderID },
      });
      return response.data;
    },
    enabled: !!orderID,
    ...options,
  });
};
